import React, { useCallback, useState } from 'react';

import api from '../api';
import { useGet, useGetOne, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { ServicesFlight } from '../types';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const FlightsProvider: React.FC<Props> = ({ children }: Props) => {
    const [data, setData] = useState<Array<ServicesFlight>>([]);
    const [selected, setSelected] = useState<ServicesFlight | null>(null);
    const [error, setError] = useState({});

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getOne = useGetOne(api, setSelected, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                get,
                getOne,
                post,
                put,
                remove,
                softDelete,
                data,
                setData,
                selected,
                setSelected,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default FlightsProvider;
